import QuestionMark from '@mui/icons-material/QuestionMark';
import { Box, ButtonBase, Typography } from '@mui/material';

import { taskBarIcons, useQueryAcessoRapido } from 'components/header/menu-shortcuts/MenuShortcuts';

export function MenuSystemShortcuts() {
    const { data = [], isFetching } = useQueryAcessoRapido();
    const buttons = data.filter((item) => item.fgAtivo);

    const hasItems = buttons.length > 0;

    if (isFetching || !hasItems) return null;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}>
            <Typography
                sx={{
                    color: 'text.secondary',
                    fontSize: '12px',
                    fontWeight: 600,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                }}
            >
                Acesso Rápido
            </Typography>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5, width: '100%' }}>
                {buttons.map((item, index) => (
                    <ButtonBase
                        key={index}
                        onClick={() => window.open(item.lkAcessoRapido, '_blank')?.focus()}
                        sx={{
                            'display': 'flex',
                            'flexDirection': 'column',
                            'alignItems': 'center',
                            'justifyContent': 'center',
                            'gap': 0.5,
                            'p': 0.75,
                            'py': 1,
                            'minHeight': 40,
                            'width': '100%',
                            'borderRadius': 1,
                            'border': '1px solid',
                            'borderColor': 'grey.300',
                            'backgroundColor': 'grey.50',
                            'color': 'text.secondary',
                            '&:hover': { backgroundColor: 'grey.100' },
                        }}
                    >
                        {taskBarIcons[item.dsIcone as keyof typeof taskBarIcons] ?? <QuestionMark />}

                        <Typography variant="caption" textAlign="center" lineHeight={1.3} color="text.secondary">
                            {item.dsAcessoRapido}
                        </Typography>
                    </ButtonBase>
                ))}
            </Box>
        </Box>
    );
}
